import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=1300a351&scoped=true&"
import script from "./Detalle.vue?vue&type=script&lang=js&"
export * from "./Detalle.vue?vue&type=script&lang=js&"
import style0 from "./Detalle.vue?vue&type=style&index=0&id=1300a351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300a351",
  null
  
)

export default component.exports